export default {
  "zh-CN": {
    "CONTENT.SELF_FOLLOW_FORBIDDEN": "不能关注自己的账号"
  },
  "en-US": {
    "CONTENT.SELF_FOLLOW_FORBIDDEN": "You cannot follow your own account."
  },
  "ar-SA": {
    "CONTENT.SELF_FOLLOW_FORBIDDEN": "لا يمكنك متابعة حسابك الخاص."
  },
  "vi-VN": {
    "CONTENT.SELF_FOLLOW_FORBIDDEN": "Bạn không thể theo dõi tài khoản của chính mình."
  }
}
